import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminEvents from "./adminevents";
import AdminIssues from "./adminissues";
import MediaManager from "./MediaManager";
import AdminEndorsements from "./AdminEndorsements";
import checkAuth from "../components/AuthCheck";

function Admin() {
  const [active, setActive] = useState("Dashboard");
  const navigate = useNavigate();
  const isLoggedIn = checkAuth();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/login'); 
    }
  }, [isLoggedIn, navigate]);

  const renderContent = () => {
    switch (active) {
      case "Dashboard":
        return <AdminEvents />;
      case "Media":
        return <MediaManager />;
      case "Subscriptions":
        return <h1>Subscription Details</h1>;
      case "Events":
        return <AdminEvents />;
      case "Issues":
        return <AdminIssues />;
      case "Endorsements":
        return <AdminEndorsements />;
      case "Mails":
        return <h1>Mailbox</h1>;
      default:
        return <h1>Dashboard Overview</h1>;
    }
  };

  return (
    <div className="app-container">
      <div className="sidebar">
        <h2>Admin Panel</h2>
        <ul>
          {["Dashboard", "Subscriptions", "Events", "Issues", "Endorsements", "Media", "Mails"].map((item) => (
              <li
                key={item}
                className={active === item ? "active" : ""}
                onClick={() => setActive(item)}
              >
                {item}
              </li>
            ))}
        </ul>
      </div>
      <div className="admin-content-container">
        {renderContent()}
      </div>
    </div>
  );
}

export default Admin;
